module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-25MARZO-25-OK__1_-small-d17d065f4933c3836dc557639746e779.png";